import { Div } from "@tblabs/truffle";


export class Box extends Div
{
    constructor(...cmps)
    {
        super();

        this.Append(...cmps);
    }
}
